var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c(
        "div",
        { staticStyle: { flex: "1" } },
        [
          _c("hamburger", {
            staticClass: "hamburger-container",
            attrs: { "is-active": _vm.sidebar.opened },
            on: { toggleClick: _vm.toggleSideBar },
          }),
          _c("div", { staticClass: "service" }, [
            _c(
              "div",
              { staticClass: "service-name" },
              [
                _vm.serviceList.length
                  ? [
                      _vm._v(
                        " 当班客服(" +
                          _vm._s(_vm.serviceList.length) +
                          ")：" +
                          _vm._s(_vm.serviceList.slice(0, 3).join(" | ")) +
                          " "
                      ),
                      _vm.serviceList.length > 3
                        ? _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "bottom-start",
                                trigger: "click",
                                "popper-class": "service-pop",
                              },
                              on: {
                                show: function ($event) {
                                  _vm.servicePopShow = true
                                },
                                hide: function ($event) {
                                  _vm.servicePopShow = false
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "service-pop__title" }, [
                                _vm._v(
                                  " 当班客服 共" +
                                    _vm._s(_vm.serviceList.length) +
                                    "人·随机排序 "
                                ),
                              ]),
                              _c("div", { staticClass: "service-pop__list" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.serviceList.join(" | ")) +
                                    " "
                                ),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "service-more",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(" 更多"),
                                  _c("i", {
                                    class: [
                                      "el-icon-arrow-down",
                                      _vm.servicePopShow && "rotate",
                                    ],
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : [_vm._v("当班客服：暂无信息")],
              ],
              2
            ),
            _c("div", [_vm._v("客服工作时间：09:00~21:00")]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _vm.head.iTalent || _vm.head.funshare || _vm.head.shop
            ? _c(
                "el-dropdown",
                {
                  staticClass: "avatar-container",
                  attrs: { trigger: "click" },
                  on: { "visible-change": _vm.toggleDropdown },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "avatar-wrapper",
                      staticStyle: { "font-size": "14px" },
                    },
                    [
                      _vm._v(" 跳转其他系统 "),
                      _c("img", {
                        staticStyle: {
                          width: "12px",
                          height: "12px",
                          "margin-left": "5px",
                        },
                        attrs: {
                          src: "https://res.youlianfuwu.com/voucher/default/jump.png",
                          alt: "",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "el-dropdown-menu",
                    { staticClass: "user-dropdown" },
                    [
                      _vm.head.iTalent
                        ? _c(
                            "el-dropdown-item",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.openBeis($event)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "jump__style",
                                attrs: {
                                  src: "https://res.youlianfuwu.com/voucher/default/beishen.jpg",
                                  alt: "",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "14px",
                                  },
                                },
                                [_vm._v("北森iTalent")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.head.funshare
                        ? _c(
                            "el-dropdown-item",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.openFenx($event)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "jump__style",
                                attrs: {
                                  src: "https://res.youlianfuwu.com/voucher/default/fx.jpg",
                                  alt: "",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "14px",
                                  },
                                },
                                [_vm._v("纷享销客")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.head.shop
                        ? _c(
                            "el-dropdown-item",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.openLiyue($event)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "jump__style",
                                attrs: {
                                  src: "https://res.youlianfuwu.com/voucher/default/shop.jpg",
                                  alt: "",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    "font-size": "14px",
                                  },
                                },
                                [_vm._v("璃月")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.$hasBtnRoles("/orders/organize-work-item/artillery-radar")
        ? _c("div", { staticClass: "down_center link-btn-group fire__style" }, [
            _c("div", { on: { click: _vm.artilleryRadar } }, [
              _vm._v("炮火雷达"),
            ]),
            _c("img", {
              staticStyle: {
                width: "12px",
                height: "12px",
                "margin-left": "5px",
              },
              attrs: {
                src: "https://res.youlianfuwu.com/voucher/default/radar.png",
                alt: "",
              },
            }),
          ])
        : _vm._e(),
      _vm.$hasBtnRoles("/user/user-download/list")
        ? _c("div", { staticClass: "down_center", on: { click: _vm.goDown } }, [
            _c("div", { staticStyle: { "margin-right": "10px" } }, [
              _vm._v("下载中心"),
            ]),
            _c("i", { staticClass: "el-icon-download" }),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "down_center notice-bell", on: { click: _vm.goNotice } },
        [
          _c(
            "el-badge",
            {
              attrs: {
                value: _vm.noticeTotal.total || 0,
                hidden: !_vm.noticeTotal.total,
                max: 999,
              },
            },
            [_c("i", { staticClass: "el-icon-bell" })]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container",
              attrs: { trigger: "click" },
              on: { "visible-change": _vm.toggleDropdown },
            },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c("img", {
                  staticClass: "img",
                  attrs: {
                    src: _vm.head.avatar
                      ? _vm.head.avatar
                      : "http://storage.youlianfuwu.com/timg.jpg",
                  },
                }),
                _vm._v(" " + _vm._s(_vm.userInfo.nick_name) + " "),
                _c("i", {
                  class: ["el-icon-caret-bottom", _vm.showDropdown && "rotate"],
                }),
              ]),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "user-dropdown",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown",
                },
                [
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.uploadAvatar($event)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.head.avatar ? "修改头像" : "上传头像"))]
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.changePassword($event)
                        },
                      },
                    },
                    [_vm._v("修改密码")]
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showBindWecom,
                          expression: "showBindWecom",
                        },
                      ],
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.bindWecom($event)
                        },
                      },
                    },
                    [_vm._v("绑定企业微信")]
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.goSystem($event)
                        },
                      },
                    },
                    [_vm._v("系统模式")]
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout($event)
                        },
                      },
                    },
                    [_vm._v(" 退出 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "下载中心",
            visible: _vm.drawer,
            size: "88%",
            "custom-class": "myDrawer",
            "append-to-body": "",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [_c("downloadCenter")],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "炮火雷达",
            visible: _vm.drawerFire,
            size: "88%",
            "custom-class": "myDrawer",
            "append-to-body": "",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerFire = $event
            },
          },
        },
        [_c("artillery-firelist")],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawerNotice,
            size: "88%",
            "custom-class": "myDrawer noticeDrawer",
            "append-to-body": "",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerNotice = $event
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c("span", { staticClass: "notice-drawer-title" }, [
              _c("span", { staticClass: "notice-bell-icon" }, [
                _c("i", { staticClass: "el-icon-message-solid" }),
              ]),
              _c("span", { staticClass: "notice-title-text" }, [
                _vm._v("公告中心"),
              ]),
              _c("span", { staticClass: "notice-range" }, [
                _vm._v("（近14天）"),
              ]),
              _c("span", { staticClass: "notice-stat" }, [
                _vm._v(
                  " 未读（" + _vm._s(_vm.noticeTotal.unread_count || 0) + "） "
                ),
              ]),
              _c("span", { staticClass: "notice-stat" }, [
                _vm._v(
                  " 未回执（" +
                    _vm._s(_vm.noticeTotal.un_callback_count || 0) +
                    "） "
                ),
              ]),
            ]),
          ]),
          _c("notice-center", {
            on: { "stat-change": _vm.handleNoticeStatChange },
          }),
        ],
        2
      ),
      _c("bind-wecom-dialog", {
        attrs: { visible: _vm.bindWecomVisible },
        on: {
          "update:visible": function ($event) {
            _vm.bindWecomVisible = $event
          },
          "bind-success": function ($event) {
            _vm.showBindWecom = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }